(function () {
  function init(root) {
    if (!root || root.dataset.m1v2SaiInit === '1') return;
    root.dataset.m1v2SaiInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sai-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sai-panel]'));
    if (!tabs.length || !panels.length) return;

    var prevBtn = root.querySelector('[data-sai-prev]');
    var nextBtn = root.querySelector('[data-sai-next]');
    var desktopMq = window.matchMedia('(min-width: 1100px)');
    var stackedMq = window.matchMedia('(min-width: 768px) and (max-width: 1099px)');

    function currentIndex() {
      var i = 0;
      tabs.forEach(function (tab, index) {
        if (tab.classList.contains('is-current')) i = index;
      });
      return i;
    }

    function syncArrows() {
      var i = currentIndex();
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= tabs.length - 1;
    }

    function go(id) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-sai-tab') === id;
        tab.classList.toggle('is-current', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-sai-panel') === id;
        panel.classList.toggle('is-current', on);
        if (stackedMq.matches) {
          panel.removeAttribute('aria-hidden');
        } else {
          panel.setAttribute('aria-hidden', on ? 'false' : 'true');
        }
      });
      syncArrows();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        go(tab.getAttribute('data-sai-tab'));
      });
      tab.addEventListener('keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = Math.min(tabs.length - 1, index + 1);
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = Math.max(0, index - 1);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        go(tabs[next].getAttribute('data-sai-tab'));
        tabs[next].focus();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var i = currentIndex() - 1;
        if (i < 0) return;
        go(tabs[i].getAttribute('data-sai-tab'));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var i = currentIndex() + 1;
        if (i >= tabs.length) return;
        go(tabs[i].getAttribute('data-sai-tab'));
      });
    }

    var stage = root.querySelector('.m1v2-sai__stage');
    var wheelLock = false;
    if (stage) {
      stage.addEventListener('wheel', function (event) {
        if (!desktopMq.matches) return;
        var dir = event.deltaY > 0 ? 1 : event.deltaY < 0 ? -1 : 0;
        if (!dir) return;
        var next = currentIndex() + dir;
        if (next < 0 || next >= tabs.length) return;
        event.preventDefault();
        if (wheelLock) return;
        wheelLock = true;
        go(tabs[next].getAttribute('data-sai-tab'));
        window.setTimeout(function () {
          wheelLock = false;
        }, 380);
      }, { passive: false });
    }

    var start = tabs[currentIndex()] || tabs[0];
    go(start.getAttribute('data-sai-tab'));
  }

  function boot() {
    document.querySelectorAll('[data-m1v2-sai]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-m1v2-sai]');
    if (!root) return;
    delete root.dataset.m1v2SaiInit;
    init(root);
  });
})();
